import * as React from 'react';
import clsx from 'clsx';
import {
    Panel,
    PanelHeader,
    PanelBody,
    CloseButton,
    PanelFooter,
    Button,
    Icons,
    ButtonGroup,
    Preloader
} from 'components';
import { WithTranslation, withTranslation } from 'react-i18next';
import './style.scss';
import {
    getOperation,
    getOmjsProjectInstance,
    getCachedFullContainers,
    getChildren,
    getOmjsViewInstance
} from 'selectors';
import { BaseLayerCode } from 'project-constants';
import { IState } from 'services/root-reducer';
import { actions as containersActions } from 'services/containers/containers-service';
import { actions as mapActions } from 'services/map/map-service';
import { connect } from 'react-redux';
import { EOperationStatus, IOperation } from 'types';
import { routes } from 'routes';

import { TabGeneral } from './tab-general';
import { TabAdditional } from './tab-additional';
import { TabLocation } from './tab-location';
import { SpecialBlueDisabledButton } from './special-blue-disabled-button';

export interface IObjectFiltersWindowProps extends WithTranslation {
    filters: IState['operations']['FILTERS'];
    containersOperation: IOperation;
    onClose: () => any;
}
export interface IObjectFiltersWindowState {
    activeTab: Tabs;
    // panelHeight: number | string
}

export enum Tabs {
    General,
    Location,
    Additional
}

export const CONTAINER_CODE = 'plots';
export const CONTAINER_ID = 1313;

const mapStateToProps = (state: IState) => ({
    filters: getOperation(state, 'FILTERS'),
    containersOperation: getOperation(state, 'CONTAINERS')
});

class ObjectFiltersWindowComponent extends React.Component<IObjectFiltersWindowProps, IObjectFiltersWindowState> {
    private TabsLabels: Map<Tabs, string>;
    private panelRef: HTMLDivElement;

    constructor(props: IObjectFiltersWindowProps) {
        super(props);

        this.state = {
            activeTab: Tabs.General
            // panelHeight: 'auto'
        };

        this.TabsLabels = new Map<Tabs, string>([
            [ Tabs.General, props.t('Основное') ],
            [ Tabs.Location, props.t('Местоположение') ],
            [ Tabs.Additional, props.t('Дополнительно') ]
        ]);

        this.switchTab = this.switchTab.bind(this);
        this.onExcelButtonClick = this.onExcelButtonClick.bind(this);
        this.onMapZoomClick = this.onMapZoomClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    componentDidMount() {

    }

    componentDidUpdate() {

    }

    getFilteredFeatures() {
        let fullContainers = getCachedFullContainers(false);
        return getChildren(false, CONTAINER_ID).reduce((acc, cont) => {
            let layer = fullContainers.find(c => c.get('code') === cont.code);
            /* eslint-disable-next-line */
            let vectorLayer = layer['vectorLayer'];
            if (layer && vectorLayer) {
                const visible = vectorLayer.getMapLayer().getVisible();
                if (visible) {
                    return [
                        ...acc,
                        ...vectorLayer.filteredSource.getFeatures()
                    ];
                }
            }

            return acc;
        }, []);
    }

    onCloseClick() {

    }

    onExcelButtonClick() {
        let { i18n } = this.props;
        let object_ids = this.getFilteredFeatures().map(c => c.get('obj').id);

        containersActions.exportObjects({
            container_code: BaseLayerCode[CONTAINER_CODE],
            object_ids: object_ids,
            lang: i18n.language
        });
    }

    onMapZoomClick() {
        let features = this.getFilteredFeatures();
        let extents = features.map(f => f.getGeometry().getExtent());

        if (extents.length > 0) {
            this.onCloseClick();

            let zoom_extent = extents.reduce((accum, curr) => {
                accum[0] = accum[0] < curr[0] ? accum[0] : curr[0];
                accum[1] = accum[1] < curr[1] ? accum[1] : curr[1];
                accum[2] = accum[2] > curr[2] ? accum[2] : curr[2];
                accum[3] = accum[3] > curr[3] ? accum[3] : curr[3];

                return accum;
            }, []);

            this.props.onClose();
            mapActions.fitToExtent(zoom_extent);
        }
    }

    switchTab(tabKey: Tabs) {
        this.setState({
            activeTab: tabKey
        });
    }

    calcObjectCount() {
        let { containersOperation } = this.props;
        let containers: any[] = containersOperation.data;

        let childs = containers.filter(c => c.parent_id === CONTAINER_ID);

        return childs.reduce((amount, c) => amount + (c.selected ? c.objectsCount : 0), 0);
    }

    renderHeader() {
        return (
            <PanelHeader>
                <div className="filters-header">
                    <span>{this.props.t('Подбор площадки')}</span>
                    <CloseButton onClick={this.props.onClose} />
                </div>
                <div className="tabs-wrapper">
                    { [ ...this.TabsLabels.entries() ].map(([ tabKey, tabLabel ]) => (
                        <div
                            key={tabKey}
                            onClick={() => { this.switchTab(tabKey); }}
                            className={clsx('tab-label', {
                                active: this.state.activeTab === tabKey
                            })}
                        >
                            <span>{tabLabel}</span>
                        </div>
                    ))}
                </div>
            </PanelHeader>
        );
    }

    renderBody() {
        let { data } = this.props.filters;
        return (
            <PanelBody>
                {(() => {
                    switch (this.state.activeTab) {
                        case Tabs.General: {
                            return (
                                <TabGeneral filters={data[CONTAINER_CODE]} />
                            );
                        }
                        case Tabs.Additional: {
                            return (
                                <TabAdditional filters={data[CONTAINER_CODE]} />
                            );
                        }
                        case Tabs.Location: {
                            return (
                                <TabLocation filters={data[CONTAINER_CODE]} />
                            );
                        }
                        default: {
                            return this.props.t('Ошибка');
                        }
                    }
                })()}
            </PanelBody>
        );
    }

    renderFooter() {
        const { t } = this.props;
        return (
            <PanelFooter>
                <ButtonGroup>
                    <Button
                        text={this.props.t('list', { count: this.calcObjectCount() })}
                        title={this.props.t('Открыть список отфильтрованных объектов')}
                        // icon={<Icons.IconList />}
                        onClick={() => {
                            routes.redirect(routes.list, {
                                layerCode: CONTAINER_CODE
                            });
                        }}
                        className="open-list-button"
                    />

                    <Button
                        title={this.props.t('Скачать отфильтрованные объекты в формате excel')}
                        disabled={this.calcObjectCount() === 0}
                        // icon={<Icons.IconExcel />}
                        text={t('Скачать xls')}
                        onClick={this.onExcelButtonClick}
                    />

                    <Button
                        title={this.props.t('Приблизить')}
                        disabled={this.calcObjectCount() === 0}
                        // icon={<Icons.IconMap />}
                        text={this.props.t('Приблизить')}
                        onClick={this.onMapZoomClick}
                    />
                </ButtonGroup>

                {/* <div className="objects-found">
                    <div className="label">{this.props.t('Найдено площадок')}</div>
                    <div className="objects-amount">{ this.calcObjectCount() }</div>
                </div> */}

                <div className="spacer" />
                <Button
                    // outlined
                    variant="icon"
                    title={this.props.t('Cбросить фильтр')}
                    onClick={() => {
                        containersActions.clearFiltersByLayerCode(CONTAINER_CODE);
                    }}
                    icon={<Icons.IconGarbageBin2 />}
                />
            </PanelFooter>
        );
    }

    render() {
        let { status } = this.props.filters;
        if (status !== EOperationStatus.SUCCESS) {
            return (
                <Panel className='object-filters-window'>
                    <Preloader />
                </Panel>
            );
        } else {
            return (
                <Panel
                    className='object-filters-window'
                    ref={el => { this.panelRef = el; }}
                >
                    { this.renderHeader() }
                    { this.renderBody() }
                    { this.renderFooter() }
                </Panel>
            );
        }
    }
}

export const ObjectFiltersWindow = withTranslation()(
    connect(mapStateToProps)(ObjectFiltersWindowComponent)
);
